import { Component, OnInit, Input, ChangeDetectionStrategy } from "@angular/core";
import { SummaryConfig } from "../../../../../common/models/flow.dto";
import { SummaryFlowViewComponent } from "../../summary-flow-view/summary-flow-view.component";
import { DefaultDisplayComponent } from "../default-display/default-display.component";


@Component({
    selector: "go-to-page-display",
    templateUrl: "./go-to-page-display.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GoToPageDisplayComponent extends DefaultDisplayComponent implements OnInit {

    @Input() message: string = "View";

    constructor() { super(); }

    ngOnInit() {
    }

    setPage(): void {
        if (this.isPreview) return;
        super.setPage();
    }

}
